import { Component, OnInit } from '@angular/core';
import {NavigatorService} from '../../services/navigatorService/navigator.service';
import {IResponse} from '../../interfaces/iresponse';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {UserService} from '../../services/api-handlers/userService/user.service';
import {UtilService} from "../../services/utilService/util.service";
import {environment as ENV} from "../../../environments/environment";
import {AuthService} from "../../services/authService/auth.service";

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.css']
})
export class VerifyAccountComponent implements OnInit {
  public username: any;
  public credentials = {
    first_code: null,
    second_code: null,
    third_code: null,
    fourth_code: null,
    fifth_code: null,
    sixth_code: null
  };
  public userDetails: any;
  loaders = {
    loading: false
  };
  constructor(private notificationService: BootstrapNotifyService,
              private userService: UserService,
              private utilService: UtilService,
              private navigatorService: NavigatorService,
              private authService: AuthService) {}
  ngOnInit(): void {
    const firstTime = localStorage.getItem('key');
    if(!firstTime){
      localStorage.setItem('key','loaded');
      window.location.reload()
    } else {
      localStorage.removeItem('key')
    }
    this.userDetails = null;
    this.utilService.setFullPageBackgroundImage();
    this.username = this.authService.getSignUpDetails();
    console.log('username', this.username);
    // this.signupObject = JSON.parse(localStorage.getItem(ENV.SIGNUP));
  }
  public verifyAccount() {
    if (!this.credentials.first_code || !this.credentials.second_code || !this.credentials.third_code || !this.credentials.fourth_code || !this.credentials.fifth_code || !this.credentials.sixth_code) {
      this.notificationService.info('You have to provide the code sent to your email to reset password!');
    } else {
      this.loaders.loading = true;
      const VerifyAccount = {
        username: this.username,
        code: this.credentials.first_code.toString() + this.credentials.second_code.toString() + this.credentials.third_code.toString() + this.credentials.fourth_code.toString() + this.credentials.fifth_code.toString() + this.credentials.sixth_code.toString()
      };
      console.log('Verify Code', VerifyAccount);
      this.userService.verifyAccount(VerifyAccount).subscribe((res: any) => {
        console.log('Request Payload', VerifyAccount);
        this.loaders.loading = false;
        setTimeout(() => {
          this.notificationService.success(res.message|| 'Successful');
        }, 5000);  //5s
          this.ngOnDestroy();
          this.navigatorService.navigateUrl('/');
      }, error => {
        this.loaders.loading = false;
        console.log('Verify Error => ', error);
        this.notificationService.error(error.error.errors, error.error.status);
        /*this.notificationService.error(error.error.message || 'Wrong Code Supplied');*/
        console.info('Error => ', error);
      });
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem(ENV.SIGNUP);
  }
}
